export var BettingOptionsClasses;
(function (BettingOptionsClasses) {
    BettingOptionsClasses["PICK_X_PREFIX"] = "PICK_";
    // Dice Duel
    BettingOptionsClasses["DD_MORE_BLACK"] = "MORE_BLACK";
    BettingOptionsClasses["DD_MORE_RED"] = "MORE_RED";
    BettingOptionsClasses["DD_ALL_BLACK"] = "ALL_BLACK";
    BettingOptionsClasses["DD_ALL_RED"] = "ALL_RED";
    BettingOptionsClasses["DD_CLUB_DEALT"] = "CLUB_DEALT";
    BettingOptionsClasses["DD_HEART_DEALT"] = "HEART_DEALT";
    BettingOptionsClasses["DD_SPADE_DEALT"] = "SPADE_DEALT";
    BettingOptionsClasses["DD_DIAMOND_DEALT"] = "DIAMOND_DEALT";
    BettingOptionsClasses["DD_NO_CLUB_DEALT"] = "NO_CLUB_DEALT";
    BettingOptionsClasses["DD_NO_HEART_DEALT"] = "NO_HEART_DEALT";
    BettingOptionsClasses["DD_NO_SPADE_DEALT"] = "NO_SPADE_DEALT";
    BettingOptionsClasses["DD_NO_DIAMOND_DEALT"] = "NO_DIAMOND_DEALT";
    BettingOptionsClasses["DD_MORE_CLUBS"] = "MORE_CLUBS";
    BettingOptionsClasses["DD_MORE_HEARTS"] = "MORE_HEARTS";
    BettingOptionsClasses["DD_MORE_SPADES"] = "MORE_SPADES";
    BettingOptionsClasses["DD_MORE_DIAMONDS"] = "MORE_DIAMONDS";
    BettingOptionsClasses["DD_ACE_DEALT"] = "ACE_DEALT";
    BettingOptionsClasses["DD_NO_ACE_DEALT"] = "NO_ACE_DEALT";
    // Starzle
    BettingOptionsClasses["STARZLE_BONUS_ONE_OUT_OF_ONE"] = "BONUS_ONE_OUT_OF_ONE";
    BettingOptionsClasses["STARZLE_BONUS_ODD"] = "BONUS_ODD";
    BettingOptionsClasses["STARZLE_BONUS_EVEN"] = "BONUS_EVEN";
    BettingOptionsClasses["STARZLE_BONUS_UNDER_24_5"] = "BONUS_UNDER_24_5";
    BettingOptionsClasses["STARZLE_BONUS_OVER_24_5"] = "BONUS_OVER_24_5";
    BettingOptionsClasses["STARZLE_BONUS_BLUE"] = "BONUS_BLUE";
    BettingOptionsClasses["STARZLE_BONUS_RED"] = "BONUS_RED";
    BettingOptionsClasses["STARZLE_BONUS_WHITE"] = "BONUS_WHITE";
    BettingOptionsClasses["STARZLE_TOTAL_OVER_147_5"] = "TOTAL_OVER_147_5";
    BettingOptionsClasses["STARZLE_TOTAL_UNDER_147_5"] = "TOTAL_UNDER_147_5";
    BettingOptionsClasses["STARZLE_COLOR_COCKTAIL_NO"] = "COLOR_COCKTAIL_NO";
    BettingOptionsClasses["STARZLE_COLOR_COCKTAIL_YES"] = "COLOR_COCKTAIL_YES";
    BettingOptionsClasses["STARZLE_FIRST_RED"] = "FIRST_RED";
    BettingOptionsClasses["STARZLE_FIRST_WHITE"] = "FIRST_WHITE";
    BettingOptionsClasses["STARZLE_FIRST_BLUE"] = "FIRST_BLUE";
    BettingOptionsClasses["STARZLE_ONE_OUT_OF_ONE"] = "ONE_OUT_OF_ONE";
    BettingOptionsClasses["STARZLE_PICK_6"] = "PICK_6";
    BettingOptionsClasses["STARZLE_BUST"] = "BUST";
    BettingOptionsClasses["STARZLE_STAR"] = "STAR";
    BettingOptionsClasses["STARZLE_MULTIPLIER"] = "MULTIPLIER";
    // Giza
    BettingOptionsClasses["GIZA_CHOSEN_SECTOR_DROPPED"] = "CHOSEN_SECTOR_DROPPED";
})(BettingOptionsClasses || (BettingOptionsClasses = {}));
